import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { CardHolderComponent } from '../../../card-holder/card-holder.component';
import { GameTableBaseComponent } from '../../components/table/game-table-base.component';

@Component({
    selector: 'app-three-headed-dragon-table',
    standalone: true,
    imports: [CommonModule, CardHolderComponent],
    templateUrl: '../../components/table/game-table-template.html',
    styleUrl: './three-headed-dragon-table.component.scss'
})
export class ThreeHeadedDragonTableComponent extends GameTableBaseComponent {}
